import axios from "axios";
const ApiKey = process.env.REACT_APP_API_KEY;
const InsuranceApiKey = process.env.REACT_APP_INSURANCE_API_KEY;
const ConversacoesApiKey = process.env.REACT_APP_CONVERSACOES_API_KEY;

const api = axios.create();
const apiWithkey = axios.create();
const insuranceApiWithKey = axios.create();
const conversacoesApiWithKey = axios.create();

apiWithkey.interceptors.request.use(function (config) {
  if (!config.headers) {
    config.headers = {};
  }
  config.headers["ApiKey"] = ApiKey;
  config.headers["api_key"] = ApiKey;
  config.headers["x-api-key"] = ApiKey;
  return config;
});

insuranceApiWithKey.interceptors.request.use(function (config) {
  if (!config.headers) {
    config.headers = {};
  }
  config.headers["ApiKey"] = InsuranceApiKey;
  config.headers["api_key"] = InsuranceApiKey;
  config.headers["x-api-key"] = InsuranceApiKey;
  return config;
});

conversacoesApiWithKey.interceptors.request.use(function (config) {
  if (!config.headers) {
    config.headers = {};
  }
  config.headers["ApiKey"] = ConversacoesApiKey;
  config.headers["api_key"] = ConversacoesApiKey;
  config.headers["x-api-key"] = ConversacoesApiKey;
  return config;
});

export { api, apiWithkey, insuranceApiWithKey, conversacoesApiWithKey };
